import { configWithWebToken } from "./config";
import { IFood } from "../models/IFood";
import { IFoodCategory } from "../models/IFoodCategory";

export const getAllFood = (restaurantId: string) =>
  configWithWebToken.get<IFood[]>("Menu/MenuListByRestourantId/" + restaurantId);

export const getFoodCategories = () =>
  configWithWebToken.get<IFoodCategory[]>("FoodCategory");
